import { render } from "./LearningCard.vue?vue&type=template&id=014f528a"
import script from "./LearningCard.vue?vue&type=script&lang=ts"
export * from "./LearningCard.vue?vue&type=script&lang=ts"
script.render = render

export default script